// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getActivities as listActivitiesAPI,
    getActivity as getActivityAPI,
    addActivity as addActivityAPI,
    updateActivity as updateActivityAPI,
    deleteActivity as deleteActivityAPI,
} from '../../helpers/';

import { activitiesApiResponseError, activitiesApiResponseSuccess } from './actions';
import { ActivitiesActionTypes } from './constants';

function* getActivity({ payload: { id } }) {
    try {
        const response = yield call(getActivityAPI, id);
        const activityItem = response.data.data;
        yield put(activitiesApiResponseSuccess(ActivitiesActionTypes.GET_ACTIVITY, activityItem));
    } catch (error) {
        yield put(activitiesApiResponseError(ActivitiesActionTypes.GET_ACTIVITY, error));
    }
}

function* addActivity({ payload: activity }) {
    try {
        const response = yield call(addActivityAPI, { ...activity })
        const activityItem = response.data
        yield put(activitiesApiResponseSuccess(ActivitiesActionTypes.ADD_ACTIVITY, activityItem))
    } catch (error) {
        yield put(activitiesApiResponseError(ActivitiesActionTypes.ADD_ACTIVITY, error))
    }
}

function* updateActivity({ payload: activity }) {
    try {
        const response = yield call(updateActivityAPI, { ...activity })
        const activityItem = response.data.data
        yield put(activitiesApiResponseSuccess(ActivitiesActionTypes.UPDATE_ACTIVITY, activityItem))
    } catch (error) {
        yield put(activitiesApiResponseError(ActivitiesActionTypes.UPDATE_ACTIVITY, error))
    }
}
function* deleteActivity({ payload: { id } }) {
    try {
        const response = yield call(deleteActivityAPI, id)
        const activityItem = response.data.id
        yield put(activitiesApiResponseSuccess(ActivitiesActionTypes.DELETE_ACTIVITY, activityItem))
    } catch (error) {
        yield put(activitiesApiResponseError(ActivitiesActionTypes.DELETE_ACTIVITY, error))
    }
}

/**
 * List contactos
 */
function* listActivities({ payload: params }) {
    try {
        const response = yield call(listActivitiesAPI, { ...params });
        const listaactivitys = response.data.data;
        yield put(activitiesApiResponseSuccess(ActivitiesActionTypes.LIST_ACTIVITIES, listaactivitys));
    } catch (error) {
        yield put(activitiesApiResponseError(ActivitiesActionTypes.LIST_ACTIVITIES, error));
    }
}


export function* watchGetActivity(): any {
    yield takeEvery(ActivitiesActionTypes.GET_ACTIVITY, getActivity);
}

export function* watchListActivities(): any {
    yield takeEvery(ActivitiesActionTypes.LIST_ACTIVITIES, listActivities);
}

export function* watchAddActivity(): any {
    yield takeEvery(ActivitiesActionTypes.ADD_ACTIVITY, addActivity)
}
export function* watchUpdateActivity(): any {
    yield takeEvery(ActivitiesActionTypes.UPDATE_ACTIVITY, updateActivity)
}
export function* watchDeleteActivity(): any {
    yield takeEvery(ActivitiesActionTypes.DELETE_ACTIVITY, deleteActivity)
}


function* activitiesSaga(): any {
    yield all([
        fork(watchGetActivity),
        fork(watchListActivities),
        fork(watchAddActivity),
        fork(watchUpdateActivity),
        fork(watchDeleteActivity),
    ]);
}

export default activitiesSaga;
